import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type PropType } from 'vue';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionModal',
  props: {
  name: { type: String, required: true },
  title: { type: String, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: _normalizeClass(["transaction-modal", [`transaction-modal--${__props.variant}`]]),
    type: "xs-fullscreen",
    variant: __props.variant,
    name: __props.name,
    title: __props.title
  }, {
    content: _withCtx(({ clear }) => [
      _renderSlot(_ctx.$slots, "content", {
        clear: clear,
        searchClass: "transaction-modal__search",
        coinSelectClass: "transaction-modal__coin-select",
        contentClass: "transaction-modal__content"
      })
    ]),
    _: 3
  }, 8, ["class", "variant", "name", "title"]))
}
}

})